import React, { useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Slider from '@material-ui/core/Slider';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import ImageUpload from './../../compoments/ImageUpload'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import Input from '@material-ui/core/Input';
import DatePicker from './../../compoments/DatePicker';
import TimePickerCustom from './../../compoments/TimePickerCustom';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  }
}));

export default function Delay({ match }) {

  const role = 'clientes';
  const roleName = 'Gerenciamento';

  const [redirect, setRedirect] = React.useState(false);
  const [id, setId] = React.useState('');
  const [name, setName] = React.useState('');
  const [login, setLogin] = React.useState(null);
  const [logout, setLogout] = React.useState(null);
  const [tempo, setTempo] = React.useState(null);
  const [retry, setRetry] = React.useState('0');
  // const [email, setEmail] = React.useState('');
  // const [email, setEmail] = React.useState('');
  // const [birthday, setBirthday] = React.useState('');
  // const [stateAddress, setStateAddress] = React.useState('');
  // const [city, setCity] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');  
  // const [previewImage, setPreviewImage] = React.useState('');
  // const [thumbnail, setThumbnail] = React.useState(null);
  // const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);

  // const preview = useMemo(() => {
  //   return thumbnail ? URL.createObjectURL(thumbnail) : null
  // }, [thumbnail])

  const handleSliderChangeRetry = (event, newValue) => {
    setRetry(newValue);
  };

  const handleInputChangeRetry = (event) => {
    setRetry(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlurRetry = () => {
    if (retry < 0) {
      setRetry(0);
    } else {
      setRetry(retry);
    }
  };

  const loadData = async () => {
    setId(match.params.id)
    const data = await api.get('/v1/gerencia/delay/')
    setRetry(data.data.delayApp)
  }

  useEffect(() => {
    loadData()
  }, [])

  const marks = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 60,
      label: '60 segundos',
    },
    {
      value: 120,
      label: '120 segundos',
    },
    {
      value: 180,
      label: '180 segundos',
    },
    {
      value: 240,
      label: '240 segundos',
    },
  ];

  const save = async () => {

    const user = new FormData();
    user.append('delayApp', retry)
    user.append('_method', 'PUT')
    try { 
      const data = await api.post('/v1/gerencia/delay', user, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      });
      if(data.status){
        setAlertTitle('Sucesso')
        setMessage('Dados alterados com sucesso')
        setAlertTitle('')
        setRedirect(`/gerencia/delay`)
      }
    } catch(error) {
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro')
    }

  }

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Typography color="textPrimary">{roleName}</Typography>
                <Typography color="textPrimary">Tempo para início</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>                    
                    <Grid item xs={3} style={{marginBottom: 20, marginTop: 20}}>
                        <Typography id="input-slider" gutterBottom>
                        Tempo para início
                        </Typography>
                      </Grid>
                      <Grid item xs={6} style={{marginBottom: 20, marginTop: 20}}>
                        <Slider
                          value={typeof retry === 'number' ? retry : 0}
                          defaultValue={30}
                          // getAriaValueText={valuetext}
                          aria-labelledby="discrete-slider"
                          valueLabelDisplay="auto"
                          step={1}
                          marks={marks}
                          min={0}
                          max={240}
                          onChange={handleSliderChangeRetry}
                        />
                    </Grid>                    
                    <Grid item xs={2} style={{marginLeft: 40, marginTop: 20}}>
                      <Input
                        style={{width: 42}}
                        value={retry}
                        margin="dense"
                        onChange={handleInputChangeRetry}
                        onBlur={handleBlurRetry}
                        inputProps={{
                          step: 1,
                          min: 0,
                          max: 240,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}